"use client";

import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import FaqAccordion from "./faq-accordion";

export default function PremiumUyelik() {
    const t = useTranslations("helpContent");

    return (
        <FaqAccordion
            items={[
                { question: t("premiumQ1"), answer: t("premiumA1") },
                { question: t("premiumQ2"), answer: t("premiumA2") },
                { question: t("premiumQ3"), answer: t("premiumA3") },
                { question: t("premiumQ4"), answer: t("premiumA4") },
                { question: t("premiumQ5"), answer: t("premiumA5") },
                {
                    question: t("premiumQ6"),
                    answer: (
                        <p>
                            {t.rich("premiumA6", {
                                link: (chunks) => (
                                    <Link
                                        href="/sozlesmeler/iptal-iade"
                                        target="_blank"
                                    >
                                        {chunks}
                                    </Link>
                                ),
                            })}
                        </p>
                    ),
                },
                { question: t("premiumQ7"), answer: t("premiumA7") },
                {
                    question: t("premiumQ8"),
                    answer: (
                        <p>
                            {t.rich("premiumA8", {
                                mail: (chunks) => (
                                    <a href="mailto:iletisim@satranc365.com">
                                        {chunks}
                                    </a>
                                ),
                            })}
                        </p>
                    ),
                },
            ]}
        />
    );
}
